import React from "react"
import RadioFilter from "../Shared/RadioFilter"

const TransportationFilter = ({ onTransportationChange, transportation }) => {
  return (
    <RadioFilter value={transportation} onChange={onTransportationChange} />
  )
}

export default TransportationFilter
